module.exports = __webpack_public_path__ + "static/img/1.003fe0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/forgeShop/1.png
// module id = SNho
// module chunks = 13